import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class FuelStationsApi extends ApiModule {
	constructor() {
		super(ModulesMap.FUEL_STATIONS, {
			entity: 'fuel_stations/stations',
		})
	}
}